import { Component, OnInit, AfterViewInit, Inject, NgZone } from '@angular/core';
import { RouterStateService } from './shared/router-state.service';
import { Observable } from 'rxjs';
import { tap, delay } from 'rxjs/operators';
import { BaseComponent } from './core';
import { DOCUMENT } from '@angular/common';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Router, NavigationEnd } from '@angular/router';
// import {
//   WidgetIsReadyService,
//   WidgetIsReadySubject,
//   WidgetStateService,
//   WidgetStateSubject,
// } from '@livechat/widget-angular';
import { ProductService } from './services';
import { AuthService } from './shared';
import { UDirectService } from './services/udirect.service';

declare global {
  interface Window {
    Calendly: any;
    LiveChatWidget: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit, AfterViewInit {
  loadedCount: Observable<string[]>;
  isLoading = false;
  /** Fab 활성화 여부 */
  isFab = true;
  /** 터치 시작 */
  start;
  /** 터치 종료 */
  end;
  /** 로그인 여부에 따른 이미지 url */
  csFabSrc = '';
  public isLiveChat: boolean = false;
  isRouterUrlSignupSimplify: boolean;
  // widgetIsReady$: WidgetIsReadySubject;
  // widgetState$: WidgetStateSubject;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private routingState: RouterStateService,
    private gtmService: GoogleTagManagerService,
    private router: Router,
    private ngZone: NgZone,
    // widgetIsReadyService: WidgetIsReadyService,
    // widgetStateService: WidgetStateService,
    public productService: ProductService,
    private authService: AuthService,
    private uDirectService:UDirectService,
  ) {
    super();
    // 상용시 console.log 무효화
    routingState.loadRouting();
    // this.widgetIsReady$ = widgetIsReadyService.subject;
    // this.widgetState$ = widgetStateService.subject;
    if(this.authService.getUser()) this.uDirectService.isEuropeDirect();
  }

  ngOnInit() {
    this.userDeviceInfo = this.deviceDetector.isDesktop() ? 'pc' : 'mobile';
    this.document.documentElement.lang = this.i18n.language;
    // this.loadedCount = this.store.select('indicator')
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });

    this.isRouterUrlSignupSimplify = this.router.url.includes('simplify');
    if (!this.isRouterUrlSignupSimplify) {
      // window.Calendly.initBadgeWidget({
      //   url: 'https://calendly.com/umma_craver',
      //   text: 'schedule a meeting',
      //   color: '#f23da6',
      //   textColor: '#ffffff',
      //   branding: false,
      // });
      // let t: any = document.querySelectorAll('.calendly-badge-widget')[0];
      // if (this.userDeviceInfo === 'pc') {
      //   t.classList.add('pc');
      // } else {
      //   t.classList.remove('pc');
      // }
    }

    // // TODO:라이브챗 사용안함
    // this.widgetIsReady$.subscribe((widgetIsReady) => {
    //   this.onAfterLoad(widgetIsReady);
    // });

    // // TODO:라이브챗 사용안함
    // this.productService.ControlFabSubject$.subscribe((result) => {
    //   this.isFab = result;
    // });

    this.csFabSrc = this.authService.getUser() ? 'chat-line' : 'mail-line';
    this.authService.onLoginSubject$.subscribe(() => {
      this.csFabSrc = this.authService.getUser() ? 'chat-line' : 'mail-line';
    });
  }

  ngAfterViewInit() {
    this.store
      .select('indicator')
      .pipe(
        delay(0),
        tap((apis) => {
          this.isLoading = apis && apis.length > 0;
        })
      )
      .subscribe();
  }

  onAfterLoad(event) {
    this.ngZone.run(() => {
      let chatWidget: any = document.querySelector('#chat-widget-container');
      if (this.userDeviceInfo !== 'mobile') {
        chatWidget?.classList.add('show');
        return;
      } else {
        this.isLiveChat = true;
        if (chatWidget) {
          chatWidget?.classList.remove('show');
        }
      }
    });
  }

  /**
   * TODO:사용안함
   * LiveChat 축소
   * @param event
   */
  onChatWindowMinimized(event) {
    // 작아지면 다시 원래대로
    document.querySelectorAll('#chat-widget-container')[0].classList.remove('show');
  }

  /**
   * 플로팅 일괄 담기 활성화
   */
  onClickBulkProducts() {
    if (
      this.productService.selectProducts.length !== 0 &&
      !['/cart', '/order', '/order/select-gift', '/order/payment', '/order/complete'].includes(this.location.path())
    )
      this.productService.emitCloseModal();
  }

  /**
   * 플로팅 CS 아이콘 활성화
   */
  onClickCS() {
    if (this.authService.getUser()) {
      this.router.navigate(['/my/inquiry']);
    } else {
      window.location.href = 'mailto:cs@umma.io';
    }
  }

  /**
   * 플로팅 팝업 on/off
   */
  onFabPopup() {
    this.isFab = !this.isFab;
  }

  /**
   * fab 버튼 swiper 이벤트 제어
   * @param event touchstart | touchend
   * @returns
   */
  onFabSwiper(event) {
    console.log(event);
    if (event.type === 'touchstart') {
      this.start = event.changedTouches[0].clientX;
      return;
    } else if (event.type === 'touchend') this.end = event.changedTouches[0].clientX;

    // start < end 왼쪽 스와이프
    if (this.start + 20 < this.end) {
      // 오른쪽 스와이프
      console.log('오른쪽 스와이프');
      this.isFab = false;
      this.start = undefined;
      this.end = undefined;
    } else if (this.start > this.end + 20) {
      // 왼쪽 스와이프
      console.log('왼쪽 스와이프');
      this.isFab = true;
      this.start = undefined;
      this.end = undefined;
    }
  }
}
